//#region Libraries
import {
    useState
} from "react";
//#endregion
import {
    Container, 
    Title, 
    ContentLocationPlaceStep1 } from "../../../styles";
import SearchInDialogAlert from "components/SearchInDialogAlert/SearchInDialogAlert";

const LocationPlaceStep1 = ({
    campusWidth, allCampus,
    campus, error,
    changeCampus, as, title = "Paso 01:", viewHelper = true
}) => {
    //#region States
    const [showDialogSearchCampus, setShowDialogSearchCampus] = useState(false);
    const [matchedCampusList, setMatchedCampusList] = useState([]);
    const [mostSimilarCampus, setMostSimilarCampus] = useState("");
    //#endregion
    const toggleDialogSearchCampus = (value = null) => {
        setShowDialogSearchCampus(value !== null ? value : !showDialogSearchCampus);
    }
    const fillMatchedCampusList = campusName => {
        const data = allCampus.map(({ id, name }) => ({
            id, text: name
        }));
        const newMatchedData = !campusName
            ? [] 
            : data.filter(
                ({ text }) => 
                    text.toUpperCase()
                        .includes(campusName.toUpperCase())
        );
        setMatchedCampusList(newMatchedData);
        if (campusName && newMatchedData.length === 0) {
            setMostSimilarCampus(data.find(
                ({ text }) => (
                    text[0].toUpperCase() === campusName[0].toUpperCase()
                )
            )?.text || "");
        }
    }
    const clearMatchedCampusList = () => setMatchedCampusList([]);
    return (
        <Container>
            <Title>{title}</Title>
            <ContentLocationPlaceStep1>
                <SearchInDialogAlert
                    widthFoundField={campusWidth}
                    buttonProps={{
                        text: "Busca el campus", 
                        variant: "secondary",
                        error,
                        errorText: "No has seleccionado un campus."
                    }}
                    placeholder="Buscar Campus UTP"
                    helperText= {viewHelper ? `*Este campus es responsable del ${as} sea interno o externo.` : ""}
                    label="Buscar el campus aquí"
                    changeSearchField={changeCampus}
                    data={matchedCampusList}
                    fillData={fillMatchedCampusList}
                    clearData={clearMatchedCampusList}
                    mostSimilar={mostSimilarCampus}
                    firstSelection={campus.id > 0}
                    name={campus.name}
                    titleDialog="Buscar el campus"
                    showDialogAlert={showDialogSearchCampus}
                    toggleDialogAlert={toggleDialogSearchCampus}
                    notFoundMessage="El campus que estás buscando no se encuentra en la lista"/>
            </ContentLocationPlaceStep1>
        </Container>
    );
}

export default LocationPlaceStep1;